import React from 'react';
import { Row, Table, Button, Glyphicon, Modal } from 'react-bootstrap';
import { withRouter } from 'react-router';
import { connect } from 'react-redux';

import Exercise from './Exercise';
import Api from '../../../api/api';

class Exercises extends React.Component {
  state = {
    exercises: this.props.exercises,
    filter: 'all',
    showConfirmationModal: false,
    exerciseNumberToBeChanged: null,
  };

  componentWillReceiveProps(nextProps) {
    this.setState({ exercises: nextProps.exercises });
  }

  handleValueChange = (number, value) => {
    Api.users.reviewExercise(number, value).then(() => {
      const exercises = this.state.exercises.slice();
      const id = number - 1;

      if (!exercises[id].review) {
        exercises[id] = {
          ...exercises[id],
          review: {
            value,
            message: null,
          },
        };
      } else {
        exercises[id].review.value = value;
      }

      this.setState({ exercises });
    });
  };

  handleFilter = filter => this.props.fetchExercises(filter);

  toggleModal = () => this.setState({ showConfirmationModal: !this.state.showConfirmationModal });

  setExerciseNumberToBeChanged = number => this.setState({ exerciseNumberToBeChanged: number });

  changeCurrentExercise = () =>
    Api.users.makeExerciseCurrent(this.state.exerciseNumberToBeChanged).then(newExercises => {
      const exercises = this.state.exercises.slice();
      const currentNumbers = newExercises.map(newExercise => newExercise.number);

      exercises.forEach(exercise => (exercise.current = currentNumbers.includes(exercise.number)));

      this.setState({ exercises, exerciseNumberToBeChanged: null });

      this.toggleModal();
    });

  render() {
    const { exercises, showConfirmationModal } = this.state;

    return (
      <div>
        <Table responsive>
          <thead>
            <tr className="first-method">
              <th>
                <span className="current-method method-th">Category</span>
              </th>
              <th>
                <span className="current-method method-th">Exercise</span>
              </th>
              <th className="handle-filter empty-exercise">
                <Button onClick={() => this.handleFilter('')}>All</Button>
              </th>
              <th className="handle-filter">
                <Button onClick={() => this.handleFilter('1')}>Yes</Button>
              </th>
              <th className="handle-filter">
                <Button onClick={() => this.handleFilter('2')}>No</Button>
              </th>
              <th className="handle-filter">
                <Button onClick={() => this.handleFilter('3')}>Undecided</Button>
              </th>
            </tr>
          </thead>
          <tbody>
            {exercises &&
              exercises.map(exercise => (
                <Exercise
                  exercise={exercise}
                  handleValueChange={this.handleValueChange}
                  key={exercise.number}
                  toggleModal={this.toggleModal}
                  setExerciseNumberToBeChanged={this.setExerciseNumberToBeChanged}
                />
              ))}
          </tbody>
        </Table>
        <div className="profile-info-buttons ch-pass download-all">
          <Button onClick={() => Api.users.downloadExercise()} bsStyle="primary">
            <Glyphicon glyph="download-alt" />
            <span className="download-text">Download all</span>
          </Button>
        </div>

        <Modal className="exercises-modal" show={showConfirmationModal} onHide={this.toggleModal}>
          <span className="litpog-remove" onClick={this.toggleModal} />
          <Modal.Header className="old-pass" closeButton>
            <Modal.Title>Are you sure you want to make this exercise current?</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <div>
              {/*<span className="exercises-modal-text">Are you sure you want to make this exercise current?</span>*/}
              <Row>
                <div className="exercises-modal-main">
                  <button className="exercises-modal-link left-link" onClick={this.toggleModal}>
                    <span className="buttons-ok-text">Cancel</span>
                  </button>
                  <button className="exercises-modal-link right-link" onClick={this.changeCurrentExercise}>
                    <span className="buttons-ok-text">ok</span>
                  </button>
                </div>
              </Row>
            </div>
          </Modal.Body>
        </Modal>
      </div>
    );
  }
}

const mapStateToProps = state => ({ exercises: state.exercises });

export default withRouter(connect(mapStateToProps)(Exercises));



// WEBPACK FOOTER //
// ./src/components/Dashboard/Exercises/Exercises.js